import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M11.275 8.375a2.656 2.656 0 0 0 1.611 2.425 6.554 6.554 0 0 1-.831 1.706c-.5.732-1.019 1.46-1.837 1.475s-1.062-.477-1.98-.477-1.206.466-1.967.496c-.789.03-1.39-.791-1.894-1.519-1.031-1.49-1.819-4.211-.761-6.047A2.937 2.937 0 0 1 6.1 4.93c.775-.015 1.507.522 1.981.522s1.363-.645 2.3-.551a2.8 2.8 0 0 1 2.195 1.191 2.714 2.714 0 0 0-1.3 2.283M9.765 3.916A2.646 2.646 0 0 0 10.389 2a2.7 2.7 0 0 0-1.768.91 2.512 2.512 0 0 0-.636 1.856 2.227 2.227 0 0 0 1.78-.849';
const draw24px = 'M17.25,12.63a4.41,4.41,0,0,0,2.68,4,11,11,0,0,1-1.38,2.85c-.84,1.21-1.7,2.43-3.06,2.45s-1.77-.79-3.3-.79-2,.77-3.28.82-2.32-1.32-3.16-2.53C4,17,2.72,12.45,4.48,9.39A4.92,4.92,0,0,1,8.62,6.88c1.29,0,2.51.87,3.3.87s2.27-1.07,3.83-.91a4.66,4.66,0,0,1,3.66,2,4.51,4.51,0,0,0-2.16,3.81M14.73,5.19a4.38,4.38,0,0,0,1-3.19,4.46,4.46,0,0,0-2.94,1.52,4.17,4.17,0,0,0-1.07,3.09,3.69,3.69,0,0,0,3-1.42';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const LogoAppleIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'logoApple'));
LogoAppleIcon.displayName = 'LogoAppleIcon';
LogoAppleIcon.propTypes = Icon.propTypes;
LogoAppleIcon.renderIcon = props => /*#__PURE__*/React.createElement(LogoAppleIcon, props);
export default LogoAppleIcon;
//# sourceMappingURL=LogoAppleIcon.js.map